import {
	ARTICLEPAGE,
	EMPLOYEEPAGE,
	ERRORPAGE,
	EVENTPAGE,
	JOBADPAGE,
	LISTPAGEWITHCATEGORIES,
	LOGINPAGE,
	NEWSPAGE,
	PASSAGEPAGE,
	PROFILEPAGE,
	SEARCHPAGE,
	STANDARDPAGE,
	STARTPAGE,
	VIDEOPAGE
} from "Consts/pageTypes";
import StartPage from "Pages/StartPage";
import StandardPage from "Pages/StandardPage";
import EmployeePage from "Pages/EmployeePage";
import SearchPage from "Pages/SearchPage";
import ErrorPage from "Pages/ErrorPage";
import PassagePage from "Pages/PassagePage";
import VideoPage from "Pages/VideoPage";
import LoginPage from "Pages/LoginPage";
import ProfilePage from "Pages/ProfilePage";
import ListPageWithCategories from "Pages/ListPageWithCategories";

import React from "react";

export const getPageType = (model, Alias, searchQuery, CurrentUser) => {
    switch (Alias) {
        case STARTPAGE:
            return <StartPage {...model} />;
        case STANDARDPAGE:
        case EVENTPAGE:
        case JOBADPAGE:
        case NEWSPAGE:
        case ARTICLEPAGE:
            return <StandardPage {...model} />;
        case EMPLOYEEPAGE:
            return <EmployeePage {...model} />;
        case SEARCHPAGE:
            return <SearchPage {...model} searchModel={searchQuery}/>;
        case LISTPAGEWITHCATEGORIES:
            return <ListPageWithCategories {...model} searchModel={searchQuery}/>;
        case ERRORPAGE:
            return <ErrorPage {...model} />;
        case LOGINPAGE:
            return <LoginPage {...model} />;
        case PASSAGEPAGE:
            return <PassagePage {...model} />;
        case VIDEOPAGE:
            return <VideoPage {...model} />;
        case PROFILEPAGE:
            return <ProfilePage {...model} CurrentUser={CurrentUser}/>;
        default:
            break;
    }
};
